import { MAX_AMOUNT, MIN_AMOUNT, snapToStop } from './amountScale';

export { MAX_AMOUNT, MIN_AMOUNT };

// `snap` rounds to the nearest scale stop — correct for the slider and
// ?amount= seeding, but manual entry should keep the user's exact value (only
// clamped to the min/max), so it passes snap: false.
export function sanitiseAmount(
  raw: string | null | undefined,
  { snap = true }: { snap?: boolean } = {},
): number | null {
  if (!raw) return null;
  const digits = raw.replace(/[^0-9]+/g, '');
  if (!digits) return null;

  const parsed = Number(digits);
  if (Number.isNaN(parsed)) return null;

  if (snap) return snapToStop(parsed);
  return Math.min(Math.max(parsed, MIN_AMOUNT), MAX_AMOUNT);
}
